import { AxiosResponse } from 'axios';

import { runGetApiRequest, runPostApiRequest, runUpdateApiRequest } from 'services/Api';

import {
  INVENTORY_AREA_ROUTE,
  INVENTORY_BRAND_ROUTE,
  INVENTORY_CATEGORY_ROUTE,
  INVENTORY_UOM_ROUTE,
  INVENTORY_SEARCH_ROUTE,
  INVENTORY_STRAIN_ROUTE,
  INVENTORY_VENDOR_ROUTE,
  INVENTORY_ADJUST_REASON_ROUTE,
  INVENTORY_ADJUST_ROUTE,
  INVENTORY_MOVE_ROUTE,
} from 'constants/apiRoutes';
import {
  GenericPaginatedGETApiResponse,
  InventoryArea,
  InventoryBrand,
  InventoryCategory,
  InventoryStrain,
  InventoryUOM,
  InventoryVendor,
} from 'types/customInventoryFilters.interface';
import {
  AdjustReason, InventoryCustomActionPayload, InventorySearchPayload, InventorySearchResponseData,
} from 'types/inventory.interface';
import { formatRoute } from 'utils/formatters';

export const postInventorySearch = (clientId: string, payload: InventorySearchPayload)
: Promise<AxiosResponse<InventorySearchResponseData>> => (
  runPostApiRequest(formatRoute(INVENTORY_SEARCH_ROUTE, { clientId }), payload)
);

export const putAdjustInventory = (clientId: string, payload: InventoryCustomActionPayload)
: Promise<AxiosResponse<void>> => (
  runUpdateApiRequest(formatRoute(INVENTORY_ADJUST_ROUTE, { clientId }), payload)
);

export const putMoveInventory = (clientId: string, payload: InventoryCustomActionPayload)
: Promise<AxiosResponse<void>> => (
  runUpdateApiRequest(formatRoute(INVENTORY_MOVE_ROUTE, { clientId }), payload)
);

export const getInventoryBrands = (clientId: string)
: Promise<AxiosResponse<GenericPaginatedGETApiResponse<InventoryBrand>>> => runGetApiRequest({
  endpoint: formatRoute(INVENTORY_BRAND_ROUTE, { clientId }),
  params: {},
});

export const getInventoryStrains = (clientId: string)
: Promise<AxiosResponse<GenericPaginatedGETApiResponse<InventoryStrain>>> => runGetApiRequest({
  endpoint: formatRoute(INVENTORY_STRAIN_ROUTE, { clientId }),
  params: {},
});

export const getInventoryAreas = (clientId: string)
: Promise<AxiosResponse<GenericPaginatedGETApiResponse<InventoryArea>>> => runGetApiRequest({
  endpoint: formatRoute(INVENTORY_AREA_ROUTE, { clientId }),
  params: {},
});

export const getInventoryVendors = (clientId: string)
: Promise<AxiosResponse<GenericPaginatedGETApiResponse<InventoryVendor>>> => runGetApiRequest({
  endpoint: formatRoute(INVENTORY_VENDOR_ROUTE, { clientId }),
  params: {},
});

export const getInventoryUOMs = (clientId: string)
: Promise<AxiosResponse<GenericPaginatedGETApiResponse<InventoryUOM>>> => runGetApiRequest({
  endpoint: formatRoute(INVENTORY_UOM_ROUTE, { clientId }),
  params: {},
});

export const getInventoryCategories = (clientId: string)
: Promise<AxiosResponse<GenericPaginatedGETApiResponse<InventoryCategory>>> => runGetApiRequest({
  endpoint: formatRoute(INVENTORY_CATEGORY_ROUTE, { clientId }),
  params: {},
});

export const getInventoryAdjustReasons = (clientId: string)
: Promise<AxiosResponse<GenericPaginatedGETApiResponse<AdjustReason>>> => runGetApiRequest({
  endpoint: formatRoute(INVENTORY_ADJUST_REASON_ROUTE, { clientId }),
  params: {},
});
